module.exports = __webpack_public_path__ + "static/media/to2030platform.ff1ecd7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/to2030platform.png
// module id = 1126
// module chunks = 0